import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { KEY_REFRESH_TOKEN, KEY_TOKEN, KEY_USER } from './auth.constants'
import type { AuthState, User } from './auth.types'

const getInitialState = () => {
  if (typeof window === 'undefined') {
    return {
      token: null,
      refreshToken: null,
      user: null,
      isAuthenticated: false,
    }
  }

  const token = localStorage.getItem(KEY_TOKEN)
  const refreshToken = localStorage.getItem(KEY_REFRESH_TOKEN)
  const userStr = localStorage.getItem(KEY_USER)
  let user: User | null = null

  if (userStr) {
    try {
      user = JSON.parse(userStr)
    } catch {
      console.error('Failed to parse user from localStorage')
    }
  }

  return {
    token,
    refreshToken,
    user,
    isAuthenticated: !!token,
  }
}

export const useAuthStore = create<AuthState>()(
  devtools(
    (set) => ({
      ...getInitialState(),
      isLoading: false,

      setAuth: (user, token, refreshToken) => {
        localStorage.setItem(KEY_TOKEN, token)
        localStorage.setItem(KEY_REFRESH_TOKEN, refreshToken)
        localStorage.setItem(KEY_USER, JSON.stringify(user))
        set({ user, token, refreshToken, isAuthenticated: true })
      },

      logout: () => {
        localStorage.removeItem(KEY_TOKEN)
        localStorage.removeItem(KEY_REFRESH_TOKEN)
        localStorage.removeItem(KEY_USER)
        set({ user: null, token: null, refreshToken: null, isAuthenticated: false })
      },

      setLoading: (loading) => set({ isLoading: loading }),
    }),
    { name: 'auth-store' },
  ),
)
